{/**
    This is a bootstrapping file for loading Quotes, nothing more.
    Its loads the quote, triggers setting the sessionStorage variables and redirects to /quote if the quote is valid, otherwise /start
*/}

import React from 'react';
import { browserHistory } from 'react-router';
import GlobalHeader from '../Fragments/GlobalHeader';
import TextInput from '../Fields/TextInput';
import HelpIcon from '../Fields/HelpIcon';
import FieldError from '../Fragments/FieldError';

let Quote = require('../Managers/Quote');
let FaSpinner = require('react-icons/lib/fa/spinner');
let QuoteError = require('../Managers/QuoteError');
let HttpService = require('../Managers/HttpService');

const Config = HttpService.getConfigForHost();
const QuoteLoadScreen = React.createClass({
    propTypes: {
        params: React.PropTypes.object.isRequired
    },

    getDefaultProps() {
        return {
            params: null,
        };
    },

    getInitialState : function() {
        return {
            isAuthing : false,
            retrievedAnswerData : undefined,
            retrievedQuoteData : undefined,
            isShowAuthFail : false,
            isRefer : false,
            referralReasons : [],
            quoteNumber : null,
            injectedQuoteNumber : null,
            isQhliHelpVisible: false,
        };
    },

    componentDidMount() {
        if (Object.keys(this.props.params).length > 0) {
            this.preloadQuote();
        }
    },

    preloadQuote() {
        let _this = this;
        Quote.loadQuote(Config.api.quoteLoad.method, Config.api.quoteLoad.url, this.props.params.quoteId).then(
            function(s) {
                if (typeof s.results === 'object') {
                    _this.setState({
                        isAuthing : true,
                        retrievedAnswerData : s.results,
                        retrievedQuoteData : s.quote,
                    });

                    if (s.referral != undefined && (s.referral == 'warning' || s.referral == 'confirmation')) {
                        _this.setState({
                            isRefer : true,
                            referralReasons : s.referral_reasons,
                            quoteNumber : s.quoteNumber,
                        });
                    }
                } else {
                    browserHistory.push('/load-quote-failed');
                }
            },
            function() {
                browserHistory.push('/load-quote-failed');
            }
        );
    },

    activeLoadQuote(event) {
        let _this = this;
        Quote.loadQuote(Config.api.quoteLoad.method, Config.api.quoteLoad.url, event.target.value.replace('/', '-')).then(
            function(s) {
                if (typeof s.results === 'object') {
                    _this.setState({
                        isAuthing : true,
                        retrievedAnswerData : s.results,
                        retrievedQuoteData : s.quote,
                    });

                    if (s.referral != undefined && (s.referral == 'warning' || s.referral == 'confirmation')) {
                        _this.setState({
                            isRefer : true,
                            referralReasons : s.referral_reasons,
                            quoteNumber : s.quoteNumber,
                        });
                    }
                }
            }
        );
    },

    passAuth : function() {
        Quote.mountQuote(this.state.retrievedAnswerData, this.state.retrievedQuoteData);
        if (this.state.isRefer) {
            QuoteError.set(QuoteError.STATUS_PRE_REFERRAL, this.state.referralReasons, this.state.quoteNumber);
            browserHistory.push('/quote-referred');
        } else {
            // Successful authentication - clear localStorage and redirect to summary
            QuoteError.clear();
            browserHistory.push('/quote');
        }
    },

    confirmAuth : function() {
        let email = this.refs.email.state.activeValue;
        let postcode = this.refs.postcode.state.activeValue;

        if (email != null && postcode != null) {
            if (postcode.replace(/ /g,'').toUpperCase() == this.state.retrievedAnswerData.ins_address_postcode.replace(/ /g,'').toUpperCase()) {
                if (email.toUpperCase() == this.state.retrievedAnswerData.email_address.toUpperCase()) {
                    this.passAuth();
                    return true;
                }
            }
        }
        this.showAuthFailed();
        return false;
    },

    showAuthFailed : function() {
        this.setState({
            isShowAuthFail : true
        });

        setTimeout(() => {
            this.setState({
                isShowAuthFail : false
            });
        }, 5000);
    },

    toggleQhliHelpText: function() {
        this.setState({
            isQhliHelpVisible: (this.state.isQhliHelpVisible) ? false : true,
        });
    },

    returnWelcomeMessage() {
        return (
            <div>
                <question-row class="no-border unpadded">
                    <div className="question-main">
                        <h1>Retrieving Quote {Object.keys(this.props.params).length > 0 ? this.props.params.quoteId.replace('-', '/') : null}</h1>
                        <div className="question-top">
                            <p>We need the details requested below to validate your identity before we can
                                continue your quote</p>
                        </div>
                    </div>
                </question-row>
                
            </div>
        );
    },

    render() {
        return (
            <div>
                <GlobalHeader />
                <div className="container stepless" />

                {Object.keys(this.props.params).length > 0 ?
                    <div>
                        {!this.state.isAuthing ?
                            <div>
                                <question-row class="unpadded">
                                    <h1>Loading quote {this.props.params.quoteId.replace('-', '/')}, please wait... <FaSpinner className="spin" /></h1>
                                </question-row>
                            </div>
                            :
                            this.returnWelcomeMessage()
                        }
                    </div>
                :
                    <div>
                        {this.returnWelcomeMessage()}

                        <question-row class="no-border">
                            <div className="question-main">
                                <div className="question-top">
                                    <label>Quote number</label>
                                    <HelpIcon onClick={this.toggleQhliHelpText} />
                                </div>
                                <div className="question-input">
                                    <input
                                        name="quote_number"
                                        id="quote_number"
                                        type="text"
                                        ref="quote_number"
                                        className="form-control"
                                        maxLength="15"
                                        onBlur={this.activeLoadQuote}
                                    />

                                    {this.state.isQhliHelpVisible ? (
                                        <div className="hint-container">
                                            <div className="hint">
                                                <div className="arrow arrow-left" />
                                                The quote number you want to retrieve e.g QHLI1234567/01
                                            </div>
                                        </div>
                                    ) : null}
                                    {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                                </div>
                            </div>
                        </question-row>
                    </div>
                }

                <TextInput
                    question="Email Address"
                    ref="email"
                    maxLength={100}
                    fieldName="retrieval_email"
                    helpText="The email address you used when you started the quote process"
                    hasBorder={!this.state.injectedQuoteNumber ? false : null}
                />

                <TextInput
                    question="Insured Address Postcode"
                    ref="postcode"
                    maxLength={50}
                    fieldName="retrieval_postcode"
                    hasBorder={false}
                />

                <question-row class="no-border">
                    <div className="form-navigation">
                        <button onClick={this.confirmAuth} className="btn btn-success btn-split-content">
                            <span>Confirm Details</span>
                        </button>
                    </div>
                </question-row>
                <question-row class="no-border">
                <div>
                    <h3>Keeping your information secure</h3>
                        <div className="question-input">
                            <p>We&rsquo;re committed to protecting your privacy. We&rsquo;ll only use the information we collect about you lawfully, in accordance with Data Protection Legislation. If you&rsquo;d like to know more about how we protect your data, please read our <a href="https://homelet.co.uk/privacy-notice"  target="_blank" className="underline">privacy policy</a>.</p>
                        </div>
                </div>
                </question-row>

                {this.state.isShowAuthFail ?
                    <div className="flash error no-margin">
                        <p>Authorisation failed. Please try again.</p>
                    </div>
                : null}
               
            </div>
        );
    }

});
export default QuoteLoadScreen;



/** WEBPACK FOOTER **
 ** ./src/components/Screens/QuoteLoadScreen.js
 **/